import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner-facultdad',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './banner-facultdad.component.html',
  styleUrl: './banner-facultdad.component.scss'
})
export class BannerFacultdadComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() info: any;
  @ViewChild('bannerContainer') bannerContainer!: ElementRef;
  private resizeObserver: any;

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    // Si el navegador soporta ResizeObserver, escuchamos cambios de tamaño del contenedor
    if (typeof ResizeObserver !== 'undefined' && this.bannerContainer?.nativeElement) {
      this.resizeObserver = new ResizeObserver(() => {
        this.checkStyles();
      });
      this.resizeObserver.observe(this.bannerContainer.nativeElement);
    }
    this.checkStyles();
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.checkStyles();
  }

  checkStyles(): void {
    if (!this.info) return;

    const banner1 = document.getElementById('banner-inscripcion');
    if (!banner1) return;

    const desktopBig = window.innerWidth > 1440;
    const desktop = window.innerWidth > 768;
    const mob = window.innerWidth < 481;

    this.info.banner_button_text_size = 18; 
    const banner1Heigth = banner1.offsetHeight;

    const banner1Texto1 = document.getElementById('banner1-texto1');
    const banner1Texto2 = document.getElementById('banner1-texto2');
    const bannerBtn1 = document.getElementById('banner-btn-1');

    if (!banner1Texto1 || !banner1Texto2 || !bannerBtn1) return;

    // Calcular tamaños finales responsivos
    const banner1Texto1Size = this.getResponsiveSizeBanner1(
      this.info.banner.bannerTextFontSize
    );
    const banner1Texto2Size = this.getResponsiveSizeBanner1(
      this.info.banner.bannerSubtitleFontSize
    );
    const bannerBtn1Size = this.getResponsiveSizeBanner1(
      this.info.banner_button_text_size
    );

    // Asignar font-size
    banner1Texto1.style.fontSize = banner1Texto1Size + 'px';
    banner1Texto2.style.fontSize = banner1Texto2Size + 'px';
    bannerBtn1.style.fontSize = bannerBtn1Size + 'px';

    // Asignar line-height y min-height
    banner1Texto1.style.lineHeight = banner1Texto1Size * 1.3 + 'px';
    banner1Texto2.style.lineHeight = banner1Texto2Size * 1.4 + 'px';
    bannerBtn1.style.minHeight = desktopBig
      ? banner1Heigth * 0.18 + 'px'
      : desktop
      ? banner1Heigth * 0.19 + 'px'
      : mob
      ? banner1Heigth * 0.1 + 'px'
      : banner1Heigth * 0.12 + 'px';
  }

  getResponsiveSizeBanner1(base: any): number {
    const width = window.innerWidth;
    const size = parseInt(base, 10) || 0;

    if (width >= 1920) return size;
    if (width >= 768) {
      const maxWidth = 1920;
      const minWidth = 768;
      const baseFactor = 0.3;
      const factor = baseFactor + ((width - minWidth) / (maxWidth - minWidth)) * (1 - baseFactor);
      return size * factor;
    }
    if (width >= 480) {
      const maxWidth = 768;
      const minWidth = 360;
      const baseFactor = 0.55;
      const factor = baseFactor + ((width - minWidth) / (maxWidth - minWidth)) * (1 - baseFactor);
      return size * factor;
    }
    return size * 0.5;
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
